<template>
  <div class="asc-spinner">
    <template v-if="!isProjectZeus">
      <v-progress-circular v-if="loading" indeterminate></v-progress-circular>
    </template>
    <template v-if="isProjectZeus">
      <div class="asc-spinner-progress--container">
        <div>
          <span>{{ loadingText }}</span>
        </div>
        <v-progress-linear
          indeterminate
          :color="getColor"
          :height="4"
        ></v-progress-linear>
      </div>
    </template>
  </div>
</template>

<script>
import AppFeatureFlags from '@/utilities/appFeatureFlags'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscSpinner',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: 'Loading Information...',
    },
  },

  computed: {
    isProjectZeus() {
      return AppFeatureFlags.getProjectZeus()
    },
    getColor() {
      return variables.accent500
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-spinner {
  text-align: center !important;

  & .asc-spinner-progress--container {
    max-width: 300px;
    margin: 0 auto;
  }
}
</style>
